import { useMutation } from "@apollo/client";
import { START_BANK_LINK } from "../graphql/company";
import { loadStripe } from "@stripe/stripe-js";
import { stripePublishableKey } from "utils/stripePublishableKey";
import { toast } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { fullName } from "utils/fullName";
import AccountType from "enums/AccountType";

const useAddHostedBankAccount = (
  userData: any,
  setClientSecret: any,
  setAccountKey: any,
  setPaymentMethod: any,
  setOpenTerms: any,
  /** The key that matches this account's platform integration, for the terms step. */
  setPublishableKey?: (key: string | null) => void,
  /** The program the bank is linked for; without one the company default issuer is used. */
  programId?: string,
  accountType?: AccountType,
) => {
  const { t } = useTranslation();
  const [addHostedBankAccount, { loading: loadingBank }] = useMutation(
    START_BANK_LINK,
    {
      variables: {
        ...(programId && { programId }),
        ...(accountType && { type: accountType }),
      },
      onCompleted: async (data) => {
        try {
          setClientSecret(data.startBankLink.clientSecret);
          setAccountKey(data.startBankLink.accountKey);
          setPublishableKey?.(data.startBankLink.publishableKey ?? null);
          const stripe = await loadStripe(
            stripePublishableKey(data.startBankLink.publishableKey),
            {
              stripeAccount: data.startBankLink.accountKey,
            },
          );

          const response = await stripe?.collectBankAccountForSetup({
            clientSecret: data.startBankLink.clientSecret,
            params: {
              payment_method_type: "us_bank_account",
              payment_method_data: {
                billing_details: {
                  name: fullName(userData?.user),
                  email: userData?.user?.email,
                },
              },
            },
          });

          if (response?.setupIntent?.status === "requires_confirmation") {
            setPaymentMethod(response?.setupIntent?.payment_method as string);
            setOpenTerms(true);
          }
          if (response?.error) {
            toast.error(t("SomethingWentWrongDescriptionWithSupport"));
          }
        } catch (error: any) {
          console.log(error);
          toast.error(t("SomethingWentWrongDescriptionWithSupport"));
        }
      },
    },
  );
  return { addHostedBankAccount, loadingBank };
};

export default useAddHostedBankAccount;
